/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RecentVisit interface.
 */
export function instanceOfRecentVisit(value) {
    if (!('hasFbclid' in value) || value['hasFbclid'] === undefined)
        return false;
    if (!('hasGclid' in value) || value['hasGclid'] === undefined)
        return false;
    if (!('hasTtclid' in value) || value['hasTtclid'] === undefined)
        return false;
    if (!('visitToken' in value) || value['visitToken'] === undefined)
        return false;
    return true;
}
export function RecentVisitFromJSON(json) {
    return RecentVisitFromJSONTyped(json, false);
}
export function RecentVisitFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'hasFbclid': json['has_fbclid'],
        'hasGclid': json['has_gclid'],
        'hasTtclid': json['has_ttclid'],
        'landingUrl': json['landing_url'] == null ? undefined : json['landing_url'],
        'utmCampaign': json['utm_campaign'] == null ? undefined : json['utm_campaign'],
        'utmContent': json['utm_content'] == null ? undefined : json['utm_content'],
        'utmMedium': json['utm_medium'] == null ? undefined : json['utm_medium'],
        'utmSource': json['utm_source'] == null ? undefined : json['utm_source'],
        'utmTerm': json['utm_term'] == null ? undefined : json['utm_term'],
        'visitToken': json['visit_token'],
        'welcomeAt': json['welcome_at'] == null ? undefined : (new Date(json['welcome_at'])),
    };
}
export function RecentVisitToJSON(json) {
    return RecentVisitToJSONTyped(json, false);
}
export function RecentVisitToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'has_fbclid': value['hasFbclid'],
        'has_gclid': value['hasGclid'],
        'has_ttclid': value['hasTtclid'],
        'landing_url': value['landingUrl'],
        'utm_campaign': value['utmCampaign'],
        'utm_content': value['utmContent'],
        'utm_medium': value['utmMedium'],
        'utm_source': value['utmSource'],
        'utm_term': value['utmTerm'],
        'visit_token': value['visitToken'],
        'welcome_at': value['welcomeAt'] == null ? value['welcomeAt'] : value['welcomeAt'].toISOString(),
    };
}
